import { DocumentAnalysisModelEnum } from '../../../../shared/models';

export const DOCUMENT_ANALYSIS_AUTOMATIC_REJECTION_DELAY = 300;

/**
 * Determine for each specific document analysis model the document type key that can use it
 *
 * The prompt model is available for all other document type keys
 */
export const DocumentAnalysisModelMapping = {
  // WPI better name
  [DocumentAnalysisModelEnum.iban]: 'bank_details',
  [DocumentAnalysisModelEnum.proof_of_address]: 'proof_of_address',
  [DocumentAnalysisModelEnum.registration_certificate]:
    'registration_certificate',
} as const satisfies Record<
  Exclude<DocumentAnalysisModelEnum, typeof DocumentAnalysisModelEnum.prompt>,
  string
>;
